export class PsDocumentStat {

    _id; // number
    _name; // string
    _color; // string
    _total; // number

    constructor(
        id,
        name,
        color,
        total,
    ) {
        this._id = id;
        this._name = name;
        this._color = color;
        this._total = total;
    }

    static fromAPIDocumentStat(stat) {
        return new this(
            stat.document_state.id,
            stat.document_state.name,
            stat.document_state.color,
            stat.total,
        );
    }

    id() {
        return this._id;
    }

    name() {
        return this._name;
    }

    color() {
        return `#${this._color}`;
    }

    total() {
        return this._total;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/company/PsDocumentStat.js